<template>
  <section class="rates-update">
    <!-- CALENDÁRIO DE SELEÇÃO -->
    <b-row align-v="end">
      <b-col class="items__left-margin">
        <FormDatepicker
          v-model="dateRange"
          :vcalendarOptions="{
            disabledDates,
            isRange: true
          }"
          :maxDate="maxDate"
          label="Adicione data"
          placeholder="dd/mm/aaaa - dd/mm/aaaa"
          size="large"
        />

        <Button :disabled="disableAddDate" size="small" @click="addDateRange()"
          >Adicionar</Button
        >
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <Paragraph
          :class="{ 'mt-2': dateRange }"
          class="primary__color"
          font-size="small"
        >
          Você pode cadastrar uma tarifa com um período máximo de
          {{ maxCalendarMonths }} meses no futuro.
        </Paragraph>
      </b-col>
    </b-row>

    <!-- LISTA DE DATAS SELECIONADAS -->
    <b-row class="mt-3 selected-dates">
      <b-col>
        <Chip
          v-for="(date, i) in selectedDates"
          :key="`${date.start}-${date.end}-${i}`"
          close
          @close="checkValue(date)"
        >
          {{ formatDate(date.rawStart, 'dd MMM yyyy') }} -
          {{ formatDate(date.rawEnd, 'dd MMM yyyy') }}
        </Chip>
      </b-col>
    </b-row>

    <!-- LINHA DIVISÓRIA -->
    <b-row v-if="canShow">
      <b-col>
        <SeparateLine :left="-10" :right="-10" />
      </b-col>
    </b-row>

    <b-row v-if="canShow">
      <b-col>
        <Heading class="subtitle-edit-tariff" level="3">
          Atualizar valores da tarifa base
        </Heading>
      </b-col>
    </b-row>

    <!-- SELEÇÃO DE DIAS DA SEMANA, TIPO DE ATUALIZAÇÃO E VALOR -->
    <b-row
      v-if="canShow"
      :class="{ block__disabled: lockTableEdition }"
      class="row-inputs"
      align-v="end"
    >
      <!-- DIAS DA SEMANA -->
      <b-col>
        <FormSelect
          v-model="selectedDays"
          :options="weekDaysOptions()"
          label="Dias da semana"
          size="large"
          multiple
          class="items__form-selected-days"
        />
      </b-col>
      <!-- TIPO DE ATUALIZAÇÃO -->
      <b-col>
        <FormSelect
          v-model="selectedUpdateType"
          :options="updateTypeOptions"
          :toggleAll="false"
          label="Tipo de atualização"
          size="large"
          class="items__form-selected-update-type"
          @change="changeUpdateType()"
        />
      </b-col>
      <!-- VALOR -->
      <b-col v-if="selectedUpdateType.value == 1">
        <PmwFormCurrencyInput
          v-model="value"
          :sufix="getCurrency"
          label="Valor"
          type="number"
          placeholder="0,00"
          size="small"
          class="items__form-input-currency items__form-value"
          @input="$emit('input', $event)"
        />
      </b-col>
      <!-- DESCONTO -->
      <b-col v-if="selectedUpdateType.value == 2">
        <PmwFormInput
          v-model="discount"
          :hasMask="true"
          :sufix="'%'"
          :disabled="isResetDiscounts"
          mask="##"
          label="Porcentagem"
          placeholder="0"
          size="small"
          class="items__form-input-currency items__form-discount"
          @input="$emit('input', $event)"
        />
      </b-col>
      <!-- ZERAR DESCONTO -->
      <b-col v-show="selectedUpdateType.value == 2">
        <InputCheckbox
          v-model="isResetDiscounts"
          :checked="isResetDiscounts"
          name="isResetDiscounts"
          class="datatable--checkbox_color items__form-is-reset-discounts"
          label="Zerar descontos"
          @change="changeUpdateType()"
        />
      </b-col>
      <!-- ADICIONAR VALOR -->
      <b-col>
        <!-- O BOTÃO SERÁ APRESENTADO NO ÚLTIMO ITEM DA LISTA -->
        <Button
          :disabled="disableAddFloatingData"
          size="small"
          @click="addFloatingData()"
        >
          Adicionar
        </Button>
      </b-col>
    </b-row>

    <!-- PREVIEW DOS DADOS -->
    <div v-if="canShow">
      <!-- Tabela de valores - flutuantes -->
      <div class="period-box">
        <Paragraph class="period-box__heading" font-size="small">
          Períodos
        </Paragraph>
        <div class="period-box__list">
          <Chip
            v-for="(date, i) in selectedDates"
            :key="`${date.start}-${date.end}-${i}`"
          >
            {{ formatDate(date.rawStart, 'dd MMM yyyy') }} -
            {{ formatDate(date.rawEnd, 'dd MMM yyyy') }}
          </Chip>
        </div>
      </div>
      <div>
        <CleanTable
          v-if="floatingDataFormated.length"
          :columns="[
            { label: 'Dias da semana', value: 'week', tooltip: false },
            { label: 'Tipo', value: 'type', tooltip: false },
            { label: 'Valor', value: 'result', tooltip: false, remove: true }
          ]"
          :rows="floatingDataFormated"
          :highlightCols="['disponibilidade']"
          @removeRow="removeFloatingData"
        />
      </div>
    </div>

    <b-row
      v-if="selectedDaysAsc.length === 0 && canShow"
      class="selectWeekDays"
    >
      <b-col>
        <Paragraph class="primary__color" font-size="small">
          Selecione os dias da semana para exibir os valores.
        </Paragraph>
      </b-col>
    </b-row>

    <!-- DETALHE DAS SOMBRAS -->
    <div
      v-if="selectedDates.length > 0 && selectedDaysAsc.length > 0"
      class="shadow-detail"
    ></div>

    <!-- EXIBIR QUANDO HOUVER DIAS DA SEMANA COM ATUALIZAÇÃO DE VALOR -->
    <b-row
      v-if="selectedDates.length > 0 && selectedDaysAsc.length > 0"
      :class="{ block__disabled: lockTableEdition }"
      class="selectWeekDays"
    >
      <b-col>
        <div
          v-if="canShow || lockTableEdition"
          class="chips-days selected-dates"
        >
          <FormField
            label="Selecione o dia da semana para visualizar na tabela"
          >
            <div class="mt-3 d-flex flex-wrap">
              <Chip
                v-for="(day, i) in selectedDaysAsc"
                :key="`${day.text}-${day.value}-${i}`"
                :class="{
                  chip__highlighted: selectedValue === day
                }"
                close
                @close="removeSelectedDay(day)"
              >
                <InputRadio
                  v-model="selectedValue"
                  :inputValue="day"
                  :label="day.text"
                  :name="day.text"
                  :checked="selectedValue === day"
                  class="input-radio-chip"
                  @change="$emit('change', selectedValue)"
                />
              </Chip>
            </div>
          </FormField>
        </div>
      </b-col>
    </b-row>

    <AlertModal
      v-model="showAlertModal"
      title="Atenção"
      icon="bell-outline"
      @alert-modal-confirm="removeSelectedDate(getPeriod)"
    >
      <template #text>
        Excluindo todos os períodos adicionados, não será possível <br />
        adicionar valores ao calendário. Deseja continuar?
      </template>
    </AlertModal>
  </section>
</template>

<script>
/**
 * Componente da Tab de atualização de tarifas do hotel
 */
import { mapGetters } from 'vuex'
import { format } from 'date-fns' // https://github.com/date-fns/date-fns
import pt from 'date-fns/locale/pt-BR'
import { getWeekDays } from '@/helpers/date'
import FormDatepicker from '@solucoes/components-lib-tmp/src/components/elements/FormDatepicker'
import Button from '@/components/_base/elements/Button'
import Paragraph from '@/components/_base/elements/Paragraph'
import Chip from '@/components/_base/patterns/Chip'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import FormField from '@/components/_base/patterns/FormField'
import FormSelect from '@/components/_base/elements/FormSelect'
import PmwFormCurrencyInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormCurrencyInput'
import InputCheckbox from '@/components/_base/elements/InputCheckbox'
import InputRadio from '@/components/_base/elements/InputRadio'
import AlertModal from '@/components/_base/patterns/AlertModal'
import SeparateLine from '@/components/_base/patterns/SeparateLine'
import CleanTable from '@/components/_base/patterns/CleanTable'
import hotelRatesConfirmationModalMixin from '@/mixins/hotelRatesConfirmationModalMixin'
import Heading from '@/components/_base/elements/Heading'

export default {
  name: 'RatesUpdate',
  mixins: [hotelRatesConfirmationModalMixin],
  components: {
    FormDatepicker,
    Button,
    Paragraph,
    Chip,
    PmwFormInput,
    FormField,
    FormSelect,
    PmwFormCurrencyInput,
    InputCheckbox,
    InputRadio,
    AlertModal,
    SeparateLine,
    CleanTable,
    Heading
  },
  props: {
    /**
     * Bloqueia a edição da tabela caso um valor tenha sido
     * inserido e todos os períodos deletados
     * */
    lockTableEdition: {
      type: Boolean,
      default: false
    },
    /**
     * Array de objetos das Tarifas Flutuantes
     * @example [
     * {
     *    selectedDays: [],
     *    value: null,
     *    discount: null,
     *    selectedUpdateType: { text: 'Valor', value: 1 }
     *  },
     * ]
     */
    floatingData: {
      type: Array,
      default: () => []
    },
    /** Tarifas flutuantes: dados formatados para exibição */
    floatingDataFormated: {
      type: Array,
      default: () => []
    },
    /** Tarifas flutuantes: dados com atualização de valor */
    floatingDataValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      maxDate: null /** Parâmetro para controle de data máxima */,
      dateRange: null,
      selectedDates: [],
      selectedDays: [],
      selectedValue: '',
      selectedUpdateType: { text: 'Valor', value: 1 },
      selectedRate: null,
      value: null,
      discount: null,
      getPeriod: null,
      updateTypeOptions: [
        { text: 'Valor', value: 1 },
        { text: 'Desconto', value: 2 }
      ],
      isResetDiscounts: false,
      showAlertModal: false,
      maxCalendarMonths: null
    }
  },
  computed: {
    /** Verifica se a tarifa pode ser adicionada */
    disableAddFloatingData() {
      return (
        !this.selectedUpdateType.value ||
        !(this.discount !== null || this.value !== null) ||
        !this.selectedDays.length ||
        !(this.weekDaysSelected.length < 7)
      )
    },
    /** Verifica se um período pode ser adicionado */
    disableAddDate() {
      return !this.dateRange
    },
    /** Retorna as datas que devem ser desabilitadas da seleção */
    disabledDates() {
      return this.selectedDates.map((item) => {
        const obj = {
          start: item.rawStart,
          end: item.rawEnd
        }

        return obj
      })
    },
    /** Se deve mostrar o elemento */
    canShow() {
      return this.selectedDates?.length
    },
    /** Ordena em ordem crescente os dias da semana selecionados (com atualização de valor)*/
    selectedDaysAsc() {
      /** Pegar os dias da semana selecionados */
      const selectedDays = []
      for (let i = 0; i < this.floatingDataValue.length; i++) {
        /** Pegar o valor do tarifa com o formato para moeda */
        const value =
          this.$options.filters[this.getCurrency](
            this.floatingDataValue[i].value
          ) || null
        /** Dias da semana com os dados formatados para visualização */
        const days = this.floatingDataValue[i].selectedDays.map((item) => {
          return {
            text: item.text + ' | ' + value,
            value: item.value
          }
        })
        selectedDays.push(...days)
      }
      return selectedDays.sort((a, b) => +a.value - +b.value)
    },
    /** Dias da semana selecionados */
    weekDaysSelected() {
      const selectedDays = []
      for (let i = 0; i < this.floatingData.length; i++) {
        selectedDays.push(...this.floatingData[i].selectedDays)
      }
      return selectedDays
    },
    ...mapGetters('hotel', ['getCurrency', 'getResetForm'])
  },
  watch: {
    selectedDays: function(newValue) {
      /**
       * Limpa o dia selecionado caso o mesmo tenha sido removido
       * da seleção de dias aplicáveis
       */
      if (newValue.findIndex((item) => item.value === this.selectedValue) < 0) {
        this.selectedValue = ''
      }

      /**
       * Caso não exista dia selecionado, seleciona
       * o primeiro da lista
       */
      if (!this.selectedValue) {
        this.selectedValue = newValue[0]?.value
        this.$emit('change', this.selectedValue)
      }

      /** Envia a(s) data(s) selecionada(s) para o componente pai */
      this.$emit('selectedWeekDays', newValue)
    },
    selectedValue: function() {
      /** Envia a(s) data(s) selecionada(s) para o componente pai */
      this.$emit('selectedDay', this.selectedValue)
    },
    selectedUpdateType: function() {
      this.$emit('typeUpdate', this.selectedUpdateType.value)
    },
    getResetForm(newVal) {
      if (newVal) {
        this.dateRange = null
        this.selectedDates = []
        this.selectedDays = []
        this.selectedValue = ''
        this.selectedUpdateType = { text: 'Valor', value: 1 }
        this.selectedRate = null
        this.value = null
        this.getPeriod = null
        this.updateTypeOptions = [
          { text: 'Valor', value: 1 },
          { text: 'Desconto', value: 2 }
        ]
        this.isResetDiscounts = false
        this.showAlertModal = false
      }
    }
  },
  created() {
    /** Realiza chamada da quantidade de meses */
    this.$calendar.getMaxMonths().then((response) => {
      this.maxCalendarMonths = response.data.numeroMesesCalendario
      const dateInicio = new Date()

      dateInicio.setMonth(dateInicio.getMonth() + this.maxCalendarMonths)

      this.maxDate = dateInicio
    })
  },
  methods: {
    /** Adicionar dados das tarifas flutuantes */
    addFloatingData() {
      this.floatingData.push({
        selectedDays: this.selectedDays,
        value: this.value,
        discount: this.discount,
        selectedUpdateType: this.selectedUpdateType
      })
      /** Limpar dados de edição */
      this.selectedDays = []
      this.value = null
      this.discount = null
      this.isResetDiscounts = false
      this.selectedUpdateType = { text: 'Valor', value: 1 }
    },
    /**
     * Padroniza o array de dias semana para popular o select
     * Trazer os dias da semana que não foram selecionados ainda
     */
    weekDaysOptions() {
      /** Percorrer os dias da semana selecionados */
      const selectedDays = []
      for (let i = 0; i < this.floatingData.length; i++) {
        selectedDays.push(
          ...this.floatingData[i].selectedDays.map((item) => item.text)
        )
      }
      /** Filtrar os dias da semana que não foram selecionados */
      const weekDays = getWeekDays().filter(
        (item) => !selectedDays.includes(item)
      )
      return weekDays.flatMap((item) => {
        return {
          text: item,
          value: getWeekDays().indexOf(item) + 1
        }
      })
    },
    /** Adiciona a data selecionada ao array de seleções */
    addDateRange() {
      this.selectedDates.push({
        rawStart: this.dateRange.start,
        start: format(this.dateRange.start, 'yyyy-MM-dd'),
        rawEnd: this.dateRange.end,
        end: format(this.dateRange.end, 'yyyy-MM-dd')
      })
      /** Limpar valores */
      this.value = null
      this.discount = null
      this.dateRange = null
      /** Atualizar períodos */
      this.$emit('period', this.selectedDates)
    },
    /**
     * Formata uma data de acordo com a string passada
     * @param {Date} date Date obj da data a ser formatada
     * @param {String} formatStr String com o formato final da data
     * @returns {String}
     */
    formatDate(date, formatStr = 'dd/MM/yyyy') {
      return format(date, formatStr, { locale: pt })
    },
    /**
     * Verifica se existe algum valor estabelecido antes de remover um período
     * Se existir, apresenta a modal de alerta
     * Se não existir, executa a função que remove o período
     * @param {Object} date Objeto com o período selecionado
     */
    checkValue(date) {
      this.getPeriod = date
      if (this.value && this.selectedDates.length === 1) {
        this.showAlertModal = true
        return
      }

      this.removeSelectedDate(date)
    },
    /**
     * Remove uma data do array de seleção
     * @param {Object} date Objeto com o período selecionado
     */
    removeSelectedDate(date) {
      const foundDate = this.selectedDates.findIndex(
        (item) => item.rawStart === date.rawStart && item.rawEnd === date.rawEnd
      )

      if (foundDate > -1) {
        this.selectedDates.splice(foundDate, 1)
      }
    },
    /**
     * Remove um dia da semana do array das Tarifas Flutuantes
     * @param {Object} day Objeto com o dia da semana selecionado
     */
    removeSelectedDay(day) {
      /** Percorrer as tarifas flutuantes */
      this.floatingData.map((item, i) => {
        /** Pegar o dia selecionado pelo value */
        const selectedDay = item.selectedDays.find(
          (item) => item.value === day.value
        )
        /** Encontrar o index do dia selecionado */
        const index = item.selectedDays.indexOf(selectedDay)
        if (index >= 0) {
          /** Remover o dia da listagem de dias da tarifa */
          item.selectedDays.splice(index, 1)
        }
        /** Se não houver mais dias selecionados, remover tarifa */
        if (item.selectedDays.length === 0) {
          this.removeFloatingData({ index: i })
        }
      })
    },
    /** Alterar o tipo de atualização (valor, desconto) da tarifa flutuante
     * @param {Object} item Objeto de Tarifa Flutuante
     */
    changeUpdateType() {
      this.value = null
      this.discount =
        this.selectedUpdateType.value === 2 && this.isResetDiscounts ? 0 : null
    },
    /** Remover uma tarifa flutuante do array
     * @param {Object} childData Objeto com o index da tarifa que será removida do array
     */
    removeFloatingData(childData) {
      this.floatingData.splice(childData.index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.selectWeekDays {
  margin-top: 30px;
}

.shadow-detail {
  position: relative;
  margin-bottom: 100px;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: -50px;
    width: calc(100% + 100px);
    height: 40px;
    @include box-shadow(0px 23px 25px -7px rgb(0 0 0 / 10%));
  }
}

/** TODO corrigir quando houver quebra de linha  */
.selected-dates {
  .chip {
    border: 1px solid $gray-border;
    margin-top: 9px;

    &__highlighted {
      border-color: $blue;
      border-width: 2px;
    }
  }
}

.subtitle-edit-tariff {
  margin-bottom: 33px;
}

.row-inputs {
  margin: {
    bottom: 30px;
  }
  .col {
    width: auto;
    flex: inherit;
  }
}

.chips-days {
  display: flex;
  position: relative;

  .chip {
    margin-top: 0;
  }
}

.input-radio-chip {
  ::v-deep .input-radio--label {
    font-size: 12px;
  }
}

.period-box {
  &__heading {
    color: $gray-dark;
    line-height: 21px;
  }
  &__list {
    margin-bottom: 12px;
    .chip {
      margin-right: -1px;
    }
  }
}

.clean-table {
  ::v-deep .clean-table-row-cell--td {
    max-width: 400px;

    p {
      line-height: 17px;
    }
  }
}

.items {
  &__left-margin {
    & > * {
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }
    }
    &--flex {
      display: flex;
      align-items: flex-end;
    }
  }
  &__form-selected-days {
    width: 188px;
  }
  &__form-selected-update-type {
    width: 181px;
  }
  &__form-value {
    width: 143px;
  }
  &__form-discount {
    width: 143px;
  }
  &__form-is-reset-discounts {
    width: 130px;
    margin-bottom: 10px;
  }
  &__form-input-currency {
    ::v-deep {
      .pmw-input {
        background-color: $pmw-white;
      }
      .pmw-form-field--label {
        font-weight: font-weight(weight-medium);
      }

      .pmw-form-field--field {
        height: 35px;
      }
    }
  }
}
</style>
